import PushNotificationConfiguration from '../entities/pushNotificationConfiguration';

const PushNotificationConfigurationDataTransformationAfterFetch = (data: any[]) => {
    return data.map((row) => {
        return new PushNotificationConfiguration(row);
    });
};

export default PushNotificationConfigurationDataTransformationAfterFetch;
